/**
 * Keep the product reviews disclosure aligned with the mobile and desktop
 * layouts while preserving the shopper's choice after their first toggle.
 * Native details behavior remains available when this module cannot load.
 */
class TuckyPdpReviews extends HTMLElement {
  constructor() {
    super();
    /** @type {HTMLDetailsElement | null} */
    this.details = null;
    /** @type {HTMLElement | null} */
    this.summary = null;
    /** @type {MediaQueryList | null} */
    this.desktopQuery = null;
    this.hasShopperChoice = false;
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
  }

  connectedCallback() {
    const details = this.querySelector('[data-product-reviews]');
    const summary = details?.querySelector('summary');

    if (!(details instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) {
      return;
    }

    this.details = details;
    this.summary = summary;
    this.desktopQuery = window.matchMedia(
      this.hasAttribute('data-mobile-collapse') ? '(min-width: 768px)' : '(min-width: 1024px)',
    );
    this.summary.addEventListener('click', this.onSummaryClick);
    this.desktopQuery.addEventListener('change', this.onBreakpointChange);

    if (!this.hasShopperChoice) {
      this.details.open = this.hasAttribute('data-always-open') || this.desktopQuery.matches;
    }
  }

  disconnectedCallback() {
    this.summary?.removeEventListener('click', this.onSummaryClick);
    this.desktopQuery?.removeEventListener('change', this.onBreakpointChange);
    this.details = null;
    this.summary = null;
    this.desktopQuery = null;
  }

  /** @param {MouseEvent} event */
  onSummaryClick(event) {
    if (
      this.hasAttribute('data-always-open') ||
      (this.hasAttribute('data-mobile-collapse') && this.desktopQuery?.matches)
    ) {
      event.preventDefault();
      return;
    }
    this.hasShopperChoice = true;
  }

  /** @param {MediaQueryListEvent} event */
  onBreakpointChange(event) {
    if (this.details && this.hasAttribute('data-mobile-collapse')) {
      this.details.open = event.matches;
      this.hasShopperChoice = false;
    } else if (this.details && !this.hasShopperChoice) {
      this.details.open = this.hasAttribute('data-always-open') || event.matches;
    }
  }
}

if (!customElements.get('tucky-product-reviews')) {
  customElements.define('tucky-product-reviews', TuckyPdpReviews);
}
